import React from 'react'
import { Button, Form, Modal, Row, Col } from 'react-bootstrap';
import { FiUpload } from "react-icons/fi";
import { checkUserPermissions } from '../../helpers/permission';

const CreateCategory = ({ show, handleClose, formik, handleImageChange, selectedCategory, loading }) => {

    return (
        <React.Fragment>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                className="modal-custom-size"
                dialogClassName="custom-modal-width"

            >
                <Form onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fw-bolder pb-3'>
                            {selectedCategory?.id ? 'Update' : 'Add new'} Category
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4 py-3 w-100">
                        <Row>
                            {/* Left Side - Text Fields */}
                            <Col md={7} className="pe-2">
                                <Form.Group className="mb-4" controlId="formCategoryName">
                                    <Form.Label className="fw-bold fs-7">Category Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Category"
                                        name='title'
                                        value={formik.values?.title}
                                        onChange={formik.handleChange}
                                        isValid={formik.touched.title && !formik.errors.title}
                                        isInvalid={formik.touched.title && !!formik.errors.title}
                                        className="rounded"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.title}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-4" controlId="formCategoryDesc">
                                    <Form.Label className="fw-bold fs-7">Category Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        placeholder='Enter Description'
                                        name='desc'
                                        value={formik.values?.desc}
                                        onChange={formik.handleChange}
                                        isValid={formik.touched.desc && !formik.errors.desc}
                                        isInvalid={formik.touched.desc && !!formik.errors.desc}
                                        className="rounded"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.desc}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            {/* Right Side - Image Upload */}
                            <Col md={5} className="d-flex flex-column align-items-center">
                                <Form.Group controlId="formFile" className="w-100">
                                    <Form.Label className="fw-bold fs-7">Category Image</Form.Label>
                                    <div
                                        className="upload-box rounded position-relative d-flex justify-content-center align-items-center mb-2"
                                        style={{
                                            border: "2px dashed #ccc",
                                            borderRadius: "12px",
                                            height: "200px",
                                            cursor: "pointer",
                                            background: "#fafafa",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <Form.Control
                                            type="file"
                                            onChange={handleImageChange}
                                            isInvalid={formik.touched.img && formik.errors.img}
                                            className="d-none"
                                            id="categoryImageInput"
                                        />

                                        <label
                                            htmlFor="categoryImageInput"
                                            className="w-100 h-100 d-flex justify-content-center align-items-center position-relative"
                                            style={{ cursor: "pointer" }}
                                        >
                                            {formik.values.img_view ? (
                                                <>
                                                    <img
                                                        src={formik.values.img_view}
                                                        alt="Category"
                                                        className="w-100 h-100 rounded"
                                                        style={{ objectFit: "cover" }}
                                                    />
                                                    {/* Hover Overlay */}
                                                    <div
                                                        className="overlay d-flex flex-column justify-content-center align-items-center"
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            background: "rgba(0,0,0,0.5)",
                                                            color: "#fff",
                                                            opacity: 0,
                                                            transition: "opacity 0.3s ease",
                                                        }}
                                                    >
                                                        <FiUpload size={28} />
                                                        <span className="mt-1 small">Change Image</span>
                                                    </div>
                                                </>
                                            ) : (
                                                <span className="text-muted small">
                                                    Click to upload image
                                                </span>
                                            )}
                                        </label>
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.img}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="px-4 py-2">
                        <Button className='cancel_btn' onClick={handleClose}>
                            Cancel
                        </Button>
                        {checkUserPermissions('manage_category') &&
                            <Button className='request_btn' type='submit' disabled={loading}>
                                {loading ? "Loading" : selectedCategory?.id ? "Update Category" : "Add Category"}
                            </Button>
                        }
                    </Modal.Footer>
                </Form>
            </Modal>



            {/* Add CSS for hover effect */}
            <style>{`
                .upload-box:hover .overlay {
                    opacity: 1 !important;
                }
                 .custom-modal-width {
          max-width: 650px;
          width: 100%;
        }
            `}</style>
        </React.Fragment>
    )
}

export default CreateCategory;